<script setup lang="ts">
import { format } from 'date-fns'
import { useFilterStore } from '@/modules/filter/stores/filter.store'

const filterStore = useFilterStore()
</script>

<template>
  <div
    class="z-30 fixed bottom-0 w-full h-6 px-3 flex items-center text-accent-light bg-accent-dark"
  >
    <div class="flex-1"></div>
    <div class="flex-none text-center font-medium text-xs">
      {{ filterStore.brand?.footerText }}
    </div>
    <div class="flex-1 flex justify-end font-light text-xs">
      {{ $t('glossary.trademark', [format(new Date(), 'yyyy')]) }}
    </div>
  </div>
</template>
